if (!customElements.get('binbank-footer')) {
  customElements.define(
    'binbank-footer',
    class BinbankFooter extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';

        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.syncPanels = () => {
          this.querySelectorAll('[data-footer-toggle]').forEach((button) => {
            const panel = this.querySelector(`#${button.getAttribute('aria-controls')}`);
            if (!panel) return;

            const expanded = !this.mobileQuery.matches;
            button.setAttribute('aria-expanded', String(expanded));
            panel.hidden = !expanded;
          });
        };

        this.syncPanels();
        this.mobileQuery.addEventListener('change', this.syncPanels);

        this.querySelectorAll('[data-footer-toggle]').forEach((button) => {
          button.addEventListener('click', () => {
            const panel = this.querySelector(`#${button.getAttribute('aria-controls')}`);
            if (!panel) return;

            const expanded = button.getAttribute('aria-expanded') === 'true';
            button.setAttribute('aria-expanded', String(!expanded));
            panel.hidden = expanded;
          });
        });
      }

      disconnectedCallback() {
        this.mobileQuery?.removeEventListener('change', this.syncPanels);
      }
    }
  );
}
